/**
 * @author      hank.chen@zumper.com (Hank Chen)
 * @copyright   Copyright (c) 2022, Zumper
 */

export const afrList = [
  { title: 'Tucson Apartments', to: '/apartments-for-rent/tucson-az' },
  {
    title: 'Sacramento Apartments',
    to: '/apartments-for-rent/sacramento-ca',
  },
  {
    title: 'Co Springs Apartments',
    to: '/apartments-for-rent/colorado-springs-co',
  },
  { title: 'Raleigh Apartments', to: '/apartments-for-rent/raleigh-nc' },
  { title: 'Orlando Apartments', to: '/apartments-for-rent/orlando-fl' },
  { title: 'St. Louis Apartments', to: '/apartments-for-rent/st-louis-mo' },
  { title: 'Greensboro Apartments', to: '/apartments-for-rent/greensboro-nc' },
  { title: 'Henderson Apartments', to: '/apartments-for-rent/henderson-nv' },
  { title: 'Syracuse Apartments', to: '/apartments-for-rent/syracuse-ny' },
  { title: 'Rochester Apartments', to: '/apartments-for-rent/rochester-ny' },
  { title: 'Buffalo Apartments', to: '/apartments-for-rent/buffalo-ny' },
  { title: 'Dayton Apartments', to: '/apartments-for-rent/dayton-oh' },
  { title: 'Cleveland Apartments', to: '/apartments-for-rent/cleveland-oh' },
  { title: 'Columbus Apartments', to: '/apartments-for-rent/columbus-oh' },
  {
    title: 'Oklahoma City Apartments',
    to: '/apartments-for-rent/oklahoma-city-ok',
  },
  { title: 'Kansas City Apartments', to: '/apartments-for-rent/kansas-city-mo' },
  { title: 'San Jose Apartments', to: '/apartments-for-rent/san-jose-ca' },
  { title: 'Omaha Apartments', to: '/apartments-for-rent/omaha-ne' },
  { title: 'Nashville Apartments', to: '/apartments-for-rent/nashville-tn' },
  { title: 'Decatur Apartments', to: '/apartments-for-rent/decatur-ga' },
  { title: 'Long Beach Apartments', to: '/apartments-for-rent/long-beach-ca' },
  { title: 'St. Paul Apartments', to: '/apartments-for-rent/st-paul-mn' },
  { title: 'Aurora Apartments', to: '/apartments-for-rent/aurora-co' },
  {
    title: 'Salt Lake City Apartments',
    to: '/apartments-for-rent/salt-lake-city-ut',
  },
  { title: 'Milwaukee Apartments', to: '/apartments-for-rent/milwaukee-wi' },
]

export const hfrList = [
  { title: 'Birmingham Houses for Rent', to: '/houses-for-rent/birmingham-al' },
  { title: 'Oakland Houses for Rent', to: '/houses-for-rent/oakland-ca' },
  { title: 'Washington Houses for Rent', to: '/houses-for-rent/washington-dc' },
  { title: 'Jacksonville Houses for Rent', to: '/houses-for-rent/jacksonville-fl' },
  { title: 'Atlanta Houses for Rent', to: '/houses-for-rent/atlanta-ga' },
  { title: 'St. Paul Houses for Rent', to: '/houses-for-rent/st-paul-mn' },
  { title: 'Greensboro Houses for Rent', to: '/houses-for-rent/greensboro-nc' },
  { title: 'Las Vegas Houses for Rent', to: '/houses-for-rent/las-vegas-nv' },
  { title: 'Syracuse Houses for Rent', to: '/houses-for-rent/syracuse-ny' },
  { title: 'Rochester Houses for Rent', to: '/houses-for-rent/rochester-ny' },
  { title: 'Buffalo Houses for Rent', to: '/houses-for-rent/buffalo-ny' },
  { title: 'Akron Houses for Rent', to: '/houses-for-rent/akron-oh' },
  { title: 'Cleveland Houses for Rent', to: '/houses-for-rent/cleveland-oh' },
  { title: 'Columbus Houses for Rent', to: '/houses-for-rent/columbus-oh' },
  { title: 'Oklahoma City Houses for Rent', to: '/houses-for-rent/oklahoma-city-ok' },
  { title: 'Portland Houses for Rent', to: '/houses-for-rent/portland-or' },
  { title: 'Philadelphia Houses for Rent', to: '/houses-for-rent/philadelphia-pa' },
  { title: 'Pittsburgh Houses for Rent', to: '/houses-for-rent/pittsburgh-pa' },
  { title: 'Nashville Houses for Rent', to: '/houses-for-rent/nashville-tn' },
  { title: 'Austin Houses for Rent', to: '/houses-for-rent/austin-tx' },
  { title: 'Dallas Houses for Rent', to: '/houses-for-rent/dallas-tx' },
  { title: 'Houston Houses for Rent', to: '/houses-for-rent/houston-tx' },
  { title: 'San Antonio Houses for Rent', to: '/houses-for-rent/san-antonio-tx' },
  { title: 'Norfolk Houses for Rent', to: '/houses-for-rent/norfolk-va' },
  { title: 'Seattle Houses for Rent', to: '/houses-for-rent/seattle-wa' },
]

export const cheapAfrList = [
  { title: 'Cheap Phoenix Apartments', to: '/apartments-for-rent/phoenix-az/cheap' },
  { title: 'Cheap Birmingham Apartments', to: '/apartments-for-rent/birmingham-al/cheap' },
  { title: 'Cheap Tucson Apartments', to: '/apartments-for-rent/tucson-az/cheap' },
  { title: 'Cheap Los Angeles Apartments', to: '/apartments-for-rent/los-angeles-ca/cheap' },
  { title: 'Cheap Sacramento Apartments', to: '/apartments-for-rent/sacramento-ca/cheap' },
  { title: 'Cheap San Diego Apartments', to: '/apartments-for-rent/san-diego-ca/cheap' },
  { title: 'Cheap San Francisco Apartments', to: '/apartments-for-rent/san-francisco-ca/cheap' },
  { title: 'Cheap Oakland Apartments', to: '/apartments-for-rent/oakland-ca/cheap' },
  { title: 'Cheap Co Springs Apartments', to: '/apartments-for-rent/colorado-springs-co/cheap' },
]

export const shortTermAfrList = [
  {
    title: 'Los Angeles Short Term Rentals',
    to: '/apartments-for-rent/los-angeles-ca/short-term',
  },
  {
    title: 'Chicago Short Term Rentals',
    to: '/apartments-for-rent/chicago-il/short-term',
  },
  {
    title: 'NYC Short Term Rentals',
    to: '/apartments-for-rent/new-york-ny/short-term',
  },
  {
    title: 'Seattle Short Term Rentals',
    to: '/apartments-for-rent/seattle-wa/short-term',
  },
  {
    title: 'Boston Short Term Rentals',
    to: '/apartments-for-rent/boston-ma/short-term',
  },
  {
    title: 'San Francisco Short Term Rentals',
    to: '/apartments-for-rent/san-francisco-ca/short-term',
  },
  {
    title: 'Fort Lauderdale Short Term Rentals',
    to: '/apartments-for-rent/fort-lauderdale-fl/short-term',
  },
  {
    title: 'San Diego Short Term Rentals',
    to: '/apartments-for-rent/san-diego-ca/short-term',
  },
  {
    title: 'Denver Short Term Rentals',
    to: '/apartments-for-rent/denver-co/short-term',
  },
  {
    title: 'Miami Beach Short Term Rentals',
    to: '/apartments-for-rent/miami-beach-fl/short-term',
  },
]

export const shortTermAfrFullList = [
  ...shortTermAfrList,
  { title: 'Oakland Short Term Rentals', to: '/apartments-for-rent/oakland-ca/short-term' },
  { title: 'Dallas Short Term Rentals', to: '/apartments-for-rent/dallas-tx/short-term' },
  { title: 'Austin Short Term Rentals', to: '/apartments-for-rent/austin-tx/short-term' },
  { title: 'Washington Short Term Rentals', to: '/apartments-for-rent/washington-dc/short-term' },
  { title: 'Phoenix Short Term Rentals', to: '/apartments-for-rent/phoenix-az/short-term' },
  {
    title: 'Minneapolis Short Term Rentals',
    to: '/apartments-for-rent/minneapolis-mn/short-term',
  },
  { title: 'San Jose Short Term Rentals', to: '/apartments-for-rent/san-jose-ca/short-term' },
  {
    title: 'Colorado Springs Short Term Rentals',
    to: '/apartments-for-rent/colorado-springs-co/short-term',
  },
  {
    title: 'Philadelphia Short Term Rentals',
    to: '/apartments-for-rent/philadelphia-pa/short-term',
  },
  {
    title: 'San Antonio Short Term Rentals',
    to: '/apartments-for-rent/san-antonio-tx/short-term',
  },
  { title: 'Las Vegas Short Term Rentals', to: '/apartments-for-rent/las-vegas-nv/short-term' },
  { title: 'Orlando Short Term Rentals', to: '/apartments-for-rent/orlando-fl/short-term' },
  { title: 'Atlanta Short Term Rentals', to: '/apartments-for-rent/atlanta-ga/short-term' },
  { title: 'Baltimore Short Term Rentals', to: '/apartments-for-rent/baltimore-md/short-term' },
  { title: 'Charlotte Short Term Rentals', to: '/apartments-for-rent/charlotte-nc/short-term' },
]

export const petFriendlyAfrList = [
  {
    title: 'Pet friendly Louisville Apartments',
    to: '/apartments-for-rent/louisville-ky/pet-friendly',
  },
  {
    title: 'Pet friendly New Orleans Apartments',
    to: '/apartments-for-rent/new-orleans-la/pet-friendly',
  },
  {
    title: 'Pet friendly Boston Apartments',
    to: '/apartments-for-rent/boston-ma/pet-friendly',
  },
  {
    title: 'Pet friendly Baltimore Apartments',
    to: '/apartments-for-rent/baltimore-md/pet-friendly',
  },
  {
    title: 'Pet friendly Detroit Apartments',
    to: '/apartments-for-rent/detroit-mi/pet-friendly',
  },
  {
    title: 'Pet friendly Battle Creek Apartments',
    to: '/apartments-for-rent/battle-creek-mi/pet-friendly',
  },
  {
    title: 'Pet friendly Grand Rapids Apartments',
    to: '/apartments-for-rent/grand-rapids-mi/pet-friendly',
  },
  {
    title: 'Pet friendly Kalamazoo Apartments',
    to: '/apartments-for-rent/kalamazoo-mi/pet-friendly',
  },
  {
    title: 'Pet friendly St. Paul Apartments',
    to: '/apartments-for-rent/st-paul-mn/pet-friendly',
  },
  {
    title: 'Pet friendly Minneapolis Apartments',
    to: '/apartments-for-rent/minneapolis-mn/pet-friendly',
  },
]

export const petFriendlyAfrFullList = [
  ...petFriendlyAfrList,
  {
    title: 'Pet friendly San Francisco Apartments',
    to: '/apartments-for-rent/san-francisco-ca/pet-friendly',
  },
  { title: 'Pet friendly Seattle Apartments', to: '/apartments-for-rent/seattle-wa/pet-friendly' },
  { title: 'Pet friendly Denver Apartments', to: '/apartments-for-rent/denver-co/pet-friendly' },
  { title: 'Pet friendly Dallas Apartments', to: '/apartments-for-rent/dallas-tx/pet-friendly' },
  {
    title: 'Pet friendly San Jose Apartments',
    to: '/apartments-for-rent/san-jose-ca/pet-friendly',
  },
  {
    title: 'Pet friendly San Antonio Apartments',
    to: '/apartments-for-rent/san-antonio-tx/pet-friendly',
  },
  { title: 'Pet friendly Austin Apartments', to: '/apartments-for-rent/austin-tx/pet-friendly' },
  { title: 'Pet friendly Chicago Apartments', to: '/apartments-for-rent/chicago-il/pet-friendly' },
  {
    title: 'Pet friendly Las Vegas Apartments',
    to: '/apartments-for-rent/las-vegas-nv/pet-friendly',
  },
  { title: 'Pet friendly Orlando Apartments', to: '/apartments-for-rent/orlando-fl/pet-friendly' },
  {
    title: 'Pet friendly Sacramento Apartments',
    to: '/apartments-for-rent/sacramento-ca/pet-friendly',
  },
  { title: 'Pet friendly Atlanta Apartments', to: '/apartments-for-rent/atlanta-ga/pet-friendly' },
  {
    title: 'Pet friendly San Diego Apartments',
    to: '/apartments-for-rent/san-diego-ca/pet-friendly',
  },
  {
    title: 'Pet friendly Washington Apartments',
    to: '/apartments-for-rent/washington-dc/pet-friendly',
  },
  {
    title: 'Pet friendly Charlotte Apartments',
    to: '/apartments-for-rent/charlotte-nc/pet-friendly',
  },
]

export const luxuryAfrList = [
  {
    title: 'Denver Luxury Apartments',
    to: '/apartments-for-rent/denver-co/luxury',
  },

  {
    title: 'Washington Luxury Apartments',
    to: '/apartments-for-rent/washington-dc/luxury',
  },

  {
    title: 'Salt Lake City Luxury Apartments',
    to: '/apartments-for-rent/salt-lake-city-ut/luxury',
  },

  {
    title: 'Ft Lauderdale Luxury Apartments',
    to: '/apartments-for-rent/fort-lauderdale-fl/luxury',
  },

  {
    title: 'Miami Luxury Apartments',
    to: '/apartments-for-rent/miami-fl/luxury',
  },

  {
    title: 'St. Louis Luxury Apartments',
    to: '/apartments-for-rent/st-louis-mo/luxury',
  },

  {
    title: 'Tampa Luxury Apartments',
    to: '/apartments-for-rent/tampa-fl/luxury',
  },

  {
    title: 'Atlanta Luxury Apartments',
    to: '/apartments-for-rent/atlanta-ga/luxury',
  },

  {
    title: 'Chicago Luxury Apartments',
    to: '/apartments-for-rent/chicago-il/luxury',
  },

  {
    title: 'Indianapolis Luxury Apartments',
    to: '/apartments-for-rent/indianapolis-in/luxury',
  },
]
